import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';
import { PoliticaPrivacidadeComponent } from './politica-privacidade.component';
import { PoliticaPrivacidadeModalComponent } from './politica-privacidade-modal/politica-privacidade-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    PoliticaPrivacidadeComponent,
    PoliticaPrivacidadeModalComponent
  ]
})
export class PoliticaPrivacidadeModule { }
